import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import MeetingData from "components/brandActivation/viewDetails/meetingData/meetingData";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DivLayout from "components/sales/divLayout/divLayout";
import CardSection from "components/sales/cardSection/cardSection";
import DocumentView from "components/sales/downloadDocView/documentView";

const UserView = ({
  match,
  userDataByUserId,
  userMeetingDetailsByUserId = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (match?.params?.id) {
        setIsLoading(true);
        await userDataByUserId(match?.params?.id, null);
        setIsLoading(false);
      }
    })();
  }, []);

  return (
    <Layout
      title={"User Details"}
      isGoback
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/brand-activation/users-rating`}
    >
      {userMeetingDetailsByUserId && userMeetingDetailsByUserId.length > 0 ? (
        userMeetingDetailsByUserId.map((details, index) => (
          <div key={index} className="panel-card">
            <div className="panel-heading">
              {`${localization.meetingDetails} (${index + 1})`}
            </div>
            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={"Client Name"}
                  data={
                    details?.client_name ? `${details.client_name}` : "Others"
                  }
                />
                <DivLayout
                  heading={"Site Id"}
                  data={details?.site_id ? `${details.site_id}` : "N/A"}
                />
                <DivLayout
                  heading={"Site No."}
                  data={details?.site_no ? `${details.site_no}` : "N/A"}
                />
                <DivLayout
                  heading={"Scheduled Date"}
                  data={
                    details?.scheduled_date
                      ? `${details.scheduled_date}`
                      : "N/A"
                  }
                />
                <DivLayout
                  heading={"Meeting Type"}
                  data={details?.eng_at ? `${details.eng_at}` : "N/A"}
                />
                <DivLayout
                  heading={"Subject"}
                  data={details?.subject ? `${details.subject}` : "N/A"}
                />
                <DivLayout
                  heading={"Body"}
                  data={details?.body ? `${details.body}` : "N/A"}
                />
                <DivLayout
                  heading={"Remark"}
                  data={details?.remark ? `${details.remark}` : "N/A"}
                />
                <DivLayout
                  heading={"Comment"}
                  data={details?.comments ? `${details.comments}` : "N/A"}
                />
                {details.rating && (
                  <DivLayout
                    heading={"Rating by immediate senior"}
                    data={details?.rating ? `${details.rating}` : "N/A"}
                  />
                )}
                {details.rating_remark && (
                  <DivLayout
                    heading={"Remark by immediate senior"}
                    data={
                      details?.rating_remark
                        ? `${details.rating_remark}`
                        : "N/A"
                    }
                  />
                )}
                {details.rated_by_email && (
                  <DivLayout
                    heading={"Rated by email"}
                    data={
                      details?.rated_by_email
                        ? `${details.rated_by_email}`
                        : "N/A"
                    }
                  />
                )}
                {details.rated_by_name && (
                  <DivLayout
                    heading={"Rated by name"}
                    data={
                      details?.rated_by_name
                        ? `${details.rated_by_name}`
                        : "N/A"
                    }
                  />
                )}

                <DocumentView
                  title={localization.attachment}
                  attachment={details?.attachment}
                />
              </div>
              {details?.details ? (
                JSON.parse(details.details).map((momItem, momIndex) => (
                  <div key={index} className="panel-card">
                    <div className="panel-heading">{`${"MOM Details"}`}</div>
                    <div className="panel-body">
                      <div key={momIndex} className="details-listing">
                        <DivLayout
                          heading={"Agenda"}
                          data={momItem.agenda ? `${momItem.agenda}` : "N/A"}
                        />
                        <DivLayout
                          heading={"Timeline"}
                          data={
                            momItem.timeline ? `${momItem.timeline}` : "N/A"
                          }
                        />
                        <DivLayout
                          heading={"Responsibility"}
                          data={
                            momItem.responsibility
                              ? `${momItem.responsibility}`
                              : "N/A"
                          }
                        />
                        <DivLayout
                          heading={"Description"}
                          data={
                            momItem.description
                              ? `${momItem.description}`
                              : "N/A"
                          }
                        />
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div key={index} className="panel-card">
                    <div className="panel-heading">{`${"MOM Details"}`}</div>
                        <div className="panel-body">
                          <div className="details-listing">
                            <DivLayout heading={"Agenda"} data={"N/A"} />
                            <DivLayout heading={"Timeline"} data={"N/A"} />
                            <DivLayout heading={"Responsibility"} data={"N/A"} />
                            <DivLayout heading={"Description"} data={"N/A"} />
                          </div>
                        </div>
                    </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div>
          {/*{localization.noRecord}*/}
          <img src={Images?.NoData} alt="" width="100%" />
        </div>
      )}
    </Layout>
  );
};

export default UserView;
